import { render, staticRenderFns } from "./RecentComments.vue?vue&type=template&id=7914b59a"
import script from "./RecentComments.vue?vue&type=script&lang=js"
export * from "./RecentComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports